import { Modal } from 'antd';
import styles from './Session.module.scss';

type RefreshConfirmationProps = {
  onRefresh: () => void;
  onCancel: () => void;
};

export default function RefreshConfirmationModal({
  onRefresh,
  onCancel,
}: RefreshConfirmationProps): JSX.Element {
  return (
    <Modal
      open
      centered
      title={<strong>Continue Session</strong>}
      closable={false}
      okText={'Continue session'}
      onOk={onCancel}
      cancelText={'New session'}
      onCancel={onRefresh}
    >
      <p className={styles.confirmRefreshContent}>
        Would you like to start a new session or continue your session?
      </p>
    </Modal>
  );
}
